commusoftCommon.directive('filePreviewSidepanel', function () {
    return {
        restrict: 'EAC',
        controller: filePreviewCtrl
    }
});